import React, { useEffect, useState } from 'react'
import Tabs, { TabContainer } from 'Components/Tabs';
import GeofenceList from './components/geofenceList'
import GeofenceSettings from './components/geofenceSetting'
import GeofenceVisibleTags from './components/geofenceVisibleTags'
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';

//Forms
import CreateEdit from './components/geofenceCreateEdit';

import { selectModuleMapSettings } from 'Redux/actions';

var varLocaleGeo = localStorage.getItem('lan');

const Geofences = (props) => {

    const { mapRef, intl } = props
    const { messages, locale } = intl;

    const [tab, setTab] = useState(0)
    const { open : openModalCreateEditGeofence } = useSelector((state) => state.realtimeMapGeofenceCreateEditModuleRedux);

    const dispatch = useDispatch()

    useEffect(()=> {
        if(varLocaleGeo != locale){
          dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default));
          varLocaleGeo = locale
        }
    },[locale]) 

    return (
        <div>
            <Tabs
                tab={tab}
                type="icon-indicator"
                border
                onChange={(tab) => {
                    setTab(tab)
                }}
            >
                <TabContainer style={{ padding: '16px 0px 0px 0px' }} iconIndicator="hexagon" label={messages['map_geofence_geofencegroups']} index={0}>
                    { tab == 0 && <GeofenceList mapRef={mapRef} />}
                </TabContainer>

                <TabContainer style={{ padding: '16px 0px 0px 0px' }} iconIndicator="build" label={messages['map_geofence_manage_geofence']} index={1}>
                    { tab == 1 && <GeofenceSettings mapRef={mapRef} /> }
                </TabContainer>

                {
                    // <TabContainer style={{ padding: '16px 0px 0px 0px' }} iconIndicator="visibility" label={messages['map_geofence_manage_visible']} index={2}>
                    //     <GeofenceVisibleTags mapRef={mapRef} />
                    // </TabContainer>
                }



            </Tabs>
            { openModalCreateEditGeofence && <CreateEdit mapRef={mapRef} /> }
        </div>
    )

}

export default injectIntl(Geofences)